/**
 * True only when running inside the packaged iOS app — the Capacitor native
 * shell reporting platform `ios`. False on Android, on the web client, and
 * during SSR.
 *
 * Use this to hide in-app purchase / web-checkout surfaces on iOS so the app
 * complies with App Store Review Guideline 3.1.1 (digital purchases must go
 * through Apple's In-App Purchase). Android keeps its existing web-checkout flow
 * (it's already live on Google Play), so we deliberately gate on iOS
 * specifically rather than the build-time `IS_MOBILE_BUILD` flag — iOS and
 * Android share one mobile bundle, so only a runtime check can tell them apart.
 */
export function isIosNative(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const cap = (
    window as unknown as {
      Capacitor?: { isNativePlatform?: () => boolean; getPlatform?: () => string };
    }
  ).Capacitor;
  return !!cap?.isNativePlatform?.() && cap?.getPlatform?.() === 'ios';
}
